module.exports = __webpack_public_path__ + "media/assets/images/category/IndepdenceDay@2x-f3bc35a42d83860f31581d9fa4ff5907.png";